import { Location } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ReportContext, ReportDefinition } from '../../report.models';
import { RouteAnalysisTableComponent } from '../route-function-report/route-analysis-report/route-analysis-table.component';
import { ServiceDeliveryReportApiService } from './service-delivery-report-api.service';
import { ServiceDeliveryRow } from './service-delivery-report.models';
import { SERVICE_DELIVERY_SUMMARY_COLUMNS, SERVICE_DELIVERY_DETAIL_COLUMNS } from './service-delivery-report.utils';

@Component({ selector: 'app-service-delivery-report', templateUrl: './service-delivery-report.component.html' })
export class ServiceDeliveryReportComponent implements OnChanges, OnDestroy {
  @Input() context!: ReportContext;
  @Input() definition!: ReportDefinition;
  @ViewChild(RouteAnalysisTableComponent) table?: RouteAnalysisTableComponent;
  rows: ServiceDeliveryRow[] = [];
  get columns() { return this.context.id === '19' ? SERVICE_DELIVERY_SUMMARY_COLUMNS : SERVICE_DELIVERY_DETAIL_COLUMNS; }
  loading = false;
  hasError = false;
  errorMessage = '';
  private version = 0;
  private destroyed = false;
  constructor(private readonly api: ServiceDeliveryReportApiService, private readonly guard: GurdServiceService,
    private readonly notify: NotificationService, private readonly other: OtherService, private readonly router: Router, private readonly location: Location) {}
  get subtitle(): string { return `از تاریخ ${this.context.startDate} الی ${this.context.endDate}`; }
  get tableKey(): string { return `service-delivery-${this.context.id}-${this.context.type}`; }
  ngOnChanges(): void {
    if (!this.context || !this.definition) return;
    ++this.version; this.loading = false; this.rows = []; this.table?.reset(); void this.loadReport();
  }
  ngOnDestroy(): void { this.destroyed = true; ++this.version; }
  goBack(): void { this.location.back(); }
  async loadReport(): Promise<void> {
    if (this.loading || this.destroyed) return;
    const version = ++this.version; this.loading = true; this.hasError = false; this.errorMessage = '';
    try {
      const result = await this.api.load(this.definition.endpoint!, { strSDate: this.context.startDate, strEDate: this.context.endDate,
        strUnitID: this.guard.decrypt(localStorage.getItem('unitId')!),
        iSystemUser: this.guard.decrypt(localStorage.getItem('ID')!), strSession: this.guard.decrypt(localStorage.getItem('Session')!) });
      if (version !== this.version) return;
      if (!Array.isArray(result)) {
        if (result.ISSessionExpired || result.ISessionExpired) {
          this.notify.showError('لطفا وارد سیستم شوید'); this.other.removeLocalStorage();
          void this.router.navigate(['login'], { queryParams: { report: this.context.id } }); return;
        }
        throw new Error(result.strError || 'دریافت اطلاعات با خطا مواجه شد');
      }
      this.rows = result.map(row => ({ ...row, displayPlate: row.strVehicleNo ? this.other.returnCorrectPlate(row.strVehicleNo) : '' }));
    } catch (error) {
      if (version !== this.version) return;
      this.rows = []; this.hasError = true; this.errorMessage = error instanceof Error ? error.message : 'دریافت اطلاعات ناموفق بود';
    } finally { if (version === this.version) this.loading = false; }
  }
}
